import { createSlice } from '@reduxjs/toolkit'
import { getCruiseCabins, addCruiseCabin, removeCruiseCabin, editCruiseCabin } from './thunks'

const initialState = {
  cabins: [],
  error: null,
  status: 'idle',
  lastFetched: null,
}

export const cruiseCabinsSlice = createSlice({
  name: 'cruiseCabins',
  initialState,
  reducers: {
    resetCruiseCabinStatus: (state) => {
      state.status = 'idle';
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCruiseCabins.pending, (state) => {
      state.status = 'loading'
    })
    builder.addCase(getCruiseCabins.fulfilled, (state, action) => {
      state.cabins = action.payload || []
      state.status = 'successful'
      state.lastFetched = Date.now()
    })
    builder.addCase(getCruiseCabins.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error
    })
    builder.addCase(addCruiseCabin.fulfilled, (state, action) => {
      state.cabins.push(action.payload)
    })
    builder.addCase(removeCruiseCabin.fulfilled, (state, action) => {
      state.cabins = state.cabins.filter(e => e.id !== action.payload)
    })
    builder.addCase(editCruiseCabin.fulfilled, (state, action) => {
      const payload = action.payload
      if (payload && payload.id) {
        state.cabins = state.cabins.map(e => e.id === payload.id ? payload : e)
      }
    })
  }
})

export const cruiseCabinsSelector = (state) => state.cruiseCabins.cabins

export const activeCruiseCabinsSelector = (state) => 
  state.cruiseCabins.cabins.filter(c => c.active === true)

export const { resetCruiseCabinStatus } = cruiseCabinsSlice.actions

export default cruiseCabinsSlice.reducer
